export default "__VITE_ASSET__1fd1d7d7__"